/**
 * Breadcrumbs Component
 * Navigation breadcrumbs showing the current page path
 */

import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"

export interface BreadcrumbItem {
  label: string
  path?: string
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[13px]">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <span key={index} className="flex items-center gap-1.25">
            {index > 0 && <ChevronRight className="w-3 h-3 text-body" />}
            {item.path && !isLast ? (
              <Link
                to={item.path}
                className="text-color-brand-offwhite hover:text-primary transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-body-ultra" : "text-body"}>{item.label}</span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
